/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React, { Component, MouseEvent } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { get } from 'lodash';
import { getCookie } from 'steamer-browserutils';
import MeetingHelper from '@tencent/docs-scenario-components-meeting-helper';
import { SuspendButtonPc, SuspendButtonMobile } from '@tencent/docs-scenario-components-suspend-button';
import { tdw } from '@tencent/tencent-doc-report';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import {
    IPlayerEvent,
    LiveRoleType,
} from '../LiveConst';
import { isPc } from './utils';
import { ITencentMeetingLiveBarProps, ITencentMeetingLiveBarStates } from './interface';
import Container from './hover-highlight-container';
import TooltipsPackage from './tooltips-package';
import * as icons from './img/liveshow';
import pcStyles from './pc.less';
import mobileStyles from './mobile.less';
import Clock from '../LiveBar/Clock';
import { IconButton, IconSwitch } from './IconButton';

import * as designIcon from './Icon';

const styles = isPc() ? pcStyles : mobileStyles;

/** 跟随主讲人按钮 */
const FollowButton = isPc() ? SuspendButtonPc : SuspendButtonMobile;

enum DOC_TYPE {
    unknown = -1,
    doc = 0,
    slide = 4,
    pdf = 6
}

export default class TencentMeetingLiveBar extends Component<ITencentMeetingLiveBarProps, ITencentMeetingLiveBarStates> {
    state: ITencentMeetingLiveBarStates = {
        hideForDocSpecial: false,
        isDraggingFollowButton: false,
    };

    componentDidMount() {
        window.addEventListener('live-components:tencent-meeting-end-play', () => {
            this.handleEndPlayTencentMeeting();
        });
    }

    handleLastPage = (event: MouseEvent) => {
        event.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.Prev, true);
    }

    handleLastPageWithToolbar = (event: MouseEvent) => {
        this.handleLastPage(event);
    }

    handleNextPage = (event: MouseEvent) => {
        event.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.Next, true);
    }

    handleNextPageWithToolbar = (event: MouseEvent) => {
        this.handleNextPage(event);
    }

    setMeetingUsersDocAuth = (policy: number, padId: string, meetingId: string) => {
        const params = {
            obj: {
                id: padId,
                type: 2,
            },
            message: '%7B%22seq%22%3A%227e91ac7c-311b-403c-ba51-520c75674fee%22%2C%22action%22%3A1%7D',
            policy: policy === 0 ? 1 : policy,
            prompt: 1,
            opt: 1,
            add: [
                {
                    userID: meetingId,
                    uidSource: 11,
                    roleID: 1,
                },
            ],
        };

        return axios.post(`/v2/privilege/set_user?xsrf=${getCookie('TOK')}`, params);
    }

    handleEndPlay = (event: MouseEvent) => {
        event.stopPropagation();
        this.props.eventCallBack(IPlayerEvent.Exit, true);
    }

    getMeetingEnv = () => {
        const envName = getCookie('env_name');
        if (!envName || /^release/.test(envName)) {
            return 'release';
        }
        if (/prerelease/.test(envName)) {
            return 'prerelease';
        }
        return 'test';
    }

    getMeetingParams = () => {
        const meetingEnv = this.getMeetingEnv();
        const meetingParamsMap = {
            test: {
                sdkId: '16282553643',
                corpId: '200008554',
            },
            prerelease: {
                sdkId: '16310196082',
                corpId: '1400212767',
            },
            release: {
                sdkId: '16272901304',
                corpId: '1400115281',
            },
        };
        return meetingParamsMap[meetingEnv];
    }

    handleEndPlayTencentMeeting = async () => {
        const { docType, padId, liveDelegate } = this.props;
        // 会议上报 https://docs.qq.com/sheet/BYeyFa0J8NYX4wVI1f2dm7HZ18QPLK0Rx8si1?tab=knagjw
        tdw({
            opername: 'doc_meet_web',
            module: 'share_in_meet',
            action: 'close_presentation',
        });
        const { sdkId, corpId } = this.getMeetingParams();
        // const docId = window.location.pathname.split('/').pop() || '';
        const docId = liveDelegate.docID;
        const meetingHelper = MeetingHelper.getInstance({ sdkId, corpId });
        const editUrl = `${location.origin}/${DOC_TYPE[docType]}/${docId}`;
        const middleUrl = `${location.origin}/scenario/meeting-auth.html?redirect_uri=`;
        const presenterUrl = `${editUrl}?login=speaker`;
        const audienceUrl = editUrl;

        try {
            const isInited = await meetingHelper.checkJsApiConfig();
            if (!isInited) {
                await meetingHelper.init();
            }
            const { meetingId = '' } = await meetingHelper.getCurrMeetingInfo() || {};
            const { policy, isOwner } = this.getPolicyAndIsOwner();
            if (isOwner) {
                await this.setMeetingUsersDocAuth(policy, padId, meetingId);
            }
            await meetingHelper.updateShareUrl({
                presenterUrl: middleUrl + encodeURIComponent(presenterUrl),
                audienceUrl: middleUrl + encodeURIComponent(audienceUrl),
            });
        } catch (err) {
            console.log('endplay error', err);
        }
    }

    handleFullscreen = (event: MouseEvent) => {
        event.stopPropagation();
        // this.fullScreenTag = true;
        this.props.eventCallBack(IPlayerEvent.FullScreen, true);
    }

    syncWithMaster = () => {
        this.props.eventCallBack(IPlayerEvent.SyncWithMaster, true);
    }

    handleZoomIn = () => {
        this.props.eventCallBack(IPlayerEvent.ZoomIn, true);
    }

    handleZoomOut = () => {
        this.props.eventCallBack(IPlayerEvent.ZoomOut, true);
    }

    liveBarConfig() {
        const { config, role } = this.props;

        const result = {
            showToolBar: get(config, 'showToolBar', true),

            // -- Group1 --
            showClock: get(config, 'showClock', false),
            // -- Group2 --
            pageTurnerBtn: get(config, 'pageTurnerBtn', true),
            // -- Group3 --
            // userListBtn: get(config, 'userListBtn', true),
            // remoteShowBtn: get(config, 'remoteShowBtn', true),
            // meetingBtn: get(config, 'meetingBtn', true),
            // noteBtn: get(config, 'noteBtn', true),
            laserBtn: get(config, 'laserBtn', true),
            // -- Group4 --
            zoomIn: get(config, 'zoomIn', false),
            zoomOut: get(config, 'zoomOut', false),
            // -- Group5 --
            // fullScreenBtn: get(config, 'fullScreenBtn', true),

            // toggleViewBtn / openPresentViewWinBtn 两者实际上是互斥的
            /** 模式一：切换备注(即演讲者视图)/观众视图 */
            toggleViewBtn: get(config, 'toggleViewBtn', false),
            /** 模式二：打开演讲者视图弹窗 */
            openPresentViewWinBtn: get(config, 'openPresentViewWinBtn', false),

            quitBtn: get(config, 'quitBtn', true),
        };
        return result;
    }

    getPolicyAndIsOwner = () => {
        const isIframe = (element: HTMLElement | null): element is HTMLIFrameElement => element !== null && element.tagName === 'IFRAME';
        const playerFrame = document.getElementById('playerFrame');
        const clientVars = (isIframe(playerFrame) ? playerFrame.contentWindow && (playerFrame.contentWindow as any).clientVars : (window as any).clientVars) || {};
        const { policy, isOwner } = clientVars;
        return { policy, isOwner };
    }

    followBtnTips = (showFollowBtn: boolean) => {
        if (!showFollowBtn) return;
        const lastShowTimestamp = localStorage.getItem('showFollowBtn');
        const oneDayTime = 86400000;
        if (lastShowTimestamp && (Date.now() - +lastShowTimestamp < oneDayTime)) return;
        Snackbar.show({
            message: '你可以自由浏览此文档',
            type: 'success',
            duration: 3000,
        })
        localStorage.setItem('showFollowBtn', String(Date.now()));
    }

    getDirectionDegree = (localPage: number, remotePage: number) => {
        if (localPage < remotePage) return 180;
        if (localPage > remotePage) return 0;

        return undefined;
    }

    renderTencentMeetingQuitBtn = () => {
        const { docType, role } = this.props;
        const { policy, isOwner } = this.getPolicyAndIsOwner();
        // 腾讯会议里的退出演示按钮
        const showQuitBtn = isOwner || [2, 3].includes(policy);
        if (!showQuitBtn && docType === DOC_TYPE.doc && role === LiveRoleType.Master) {
            // doc演讲者如果没有退出演示按钮，则应该隐藏整个工具栏
            this.setState({
                hideForDocSpecial: true,
            })
        }
        return (
            showQuitBtn && (
                <TooltipsPackage
                    options={{
                        title: '退出演示',
                    }}
                >
                    {docType === DOC_TYPE.doc
                        ? <div className={styles.docEndPlayWrap} onClick={this.handleEndPlayTencentMeeting} >
                            <img src={icons.END_PLAY_WHITE}></img>
                            <div>退出演示</div>
                        </div>
                        : <div className={styles.btnWrap} onClick={this.handleEndPlayTencentMeeting} >
                            <img src={icons.END_PLAY_WHITE}></img>
                        </div>
                    }
                </TooltipsPackage>
            )
        );
    }

    render() {
        const { docType, liveDelegate, currentPage = 0, pageCount = 0, role, presentControllerClassName } = this.props;
        const { hideForDocSpecial } = this.state;

        // NOTE: this.props.currentPage 是 index, 而 liveDelegate.liveInfo.page 为实际页数
        const localPage = currentPage + 1;
        const remotePage = liveDelegate.liveInfo.page;
        /** 页数文案 1 / 10 */
        const pageText = `${Math.min(localPage, pageCount)} / ${pageCount}`;

        const isAudience = role === LiveRoleType.Audience;
        const asyncInfo = liveDelegate && liveDelegate.getAsyncInfo;
        const allowFlip = !isAudience || liveDelegate.allowFlip();

        // FIXME: 
        const showFollowBtn = asyncInfo?.length > 0 && liveDelegate.isManulFlipped && allowFlip && isAudience;
        this.followBtnTips(showFollowBtn);

        // 按钮是否启用的配置
        const liveBarCfg = this.liveBarConfig();

        return (
            <div className={styles.toolbarWrapper} 
                style={{ 
                    opacity: liveBarCfg.showToolBar ? 1 : 0,
                    // 只有 pc 需要在 dragging 时设置父容器相应鼠标事件
                    // mobile 应一直为 none
                    // TODO: mobile 不需要 onDragEnd/Start & isDragging 状态
                    pointerEvents: (isPc() && this.state.isDraggingFollowButton) ? 'all' : 'none',
                }}
            >
                <div className={styles.container}>
                    {isAudience && 
                        <FollowButton 
                            style={{ 
                                cursor: 'pointer',
                                display: showFollowBtn ? '' : 'none',
                            }}
                            imgUrl={liveDelegate.masterAvatar ?? ''} 
                            directionDegree={this.getDirectionDegree(localPage, remotePage)} 
                            onClick={this.syncWithMaster} 
                            onDragStart={() => this.setState({ isDraggingFollowButton: true })}
                            onDragEnd={() => this.setState({ isDraggingFollowButton: false })}
                        />
                    }

                    {(docType !== DOC_TYPE.doc || role !== LiveRoleType.Audience) && !hideForDocSpecial &&
                        <Container presentControllerClassName={presentControllerClassName}>
                        {/* 时钟 */}
                        {liveBarCfg.showClock && <Clock />}
                        {/* 页码 */}
                        {liveBarCfg.pageTurnerBtn && this.props.showFlip &&
                            <>
                                {allowFlip &&
                                    <IconButton 
                                        title='上一页'
                                        icon={icons.PREV}
                                        onClick={this.handleLastPageWithToolbar}
                                    />
                                }
                                <div className={styles.pageInfo}>{pageText}</div>
                                {allowFlip &&
                                    <IconButton 
                                        title='下一页'
                                        icon={icons.NEXT}
                                        onClick={this.handleNextPageWithToolbar}
                                    />
                                }
                            </>
                        }
                        {liveBarCfg.laserBtn && role === LiveRoleType.Master && 
                            <IconSwitch  
                                titleOn="关闭激光笔"
                                titleOff="打开激光笔"
                                iconOn={designIcon.laserpenActive}
                                iconOff={designIcon.laserpenNormal}
                                value={!!this.props.laserTurnOn}
                                onChange={(value) => this.props.eventCallBack(IPlayerEvent.Laser, value)} 
                            />
                        }

                        {/* 放大缩小按钮 */}
                        {(liveBarCfg.zoomIn || liveBarCfg.zoomOut) &&
                        <>
                            {liveBarCfg.zoomIn &&
                                <IconButton 
                                    title='页面放大'
                                    icon={icons.ZOOM_IN}
                                    onClick={this.handleZoomIn}
                                />
                            }
                            {liveBarCfg.zoomOut &&
                                <IconButton 
                                    title='页面缩小'
                                    icon={icons.ZOOM_OUT}
                                    onClick={this.handleZoomOut}
                                />
                            }
                        </>
                        }

                        {/* 切换演讲者模式 */}
                        {liveBarCfg.toggleViewBtn && role === LiveRoleType.Master && 
                            <IconSwitch
                                titleOn="切换观众视图"
                                titleOff="切换备注视图"
                                iconOn={icons.VIEW_SWITCH}
                                iconOff={icons.VIEW_SWITCH}
                                value={!!this.props.isPresenterView}
                                onChange={(value) => this.props.eventCallBack(IPlayerEvent.ToggleView, value)} 
                            />
                        }
                        {liveBarCfg.openPresentViewWinBtn && role === LiveRoleType.Master && 
                            <IconButton
                                title="备注视图"
                                icon={designIcon.notePage}
                                onClick={() => this.props.eventCallBack(IPlayerEvent.OpenPresenterViewWindow)} 
                            />
                        }

                        {/* 关闭演示 */}
                        {liveBarCfg.quitBtn && role === LiveRoleType.Master && this.renderTencentMeetingQuitBtn()}
                    </Container>}
                </div>
            </div>
        );
    }
}
